// src/pages/ContactDetailPage.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";



function ContactDetailLeadWebStyle() {
    return (
        <style>{`
            .contact-detail-pro{color:#f5fbff}
            .contact-detail-pro select option{background:#061a2f;color:white}
            .contact-detail-pro .crm-hero{background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%);border:1px solid rgba(11,93,140,.8);box-shadow:0 20px 45px rgba(0,0,0,.28)}
            .contact-detail-pro .crm-card{border:1px solid rgba(11,93,140,.82);background:#04192b;box-shadow:0 12px 30px rgba(0,0,0,.24)}
            .contact-detail-pro .crm-card-head{background:#031425;border-bottom:1px solid #0b4d78}
            .contact-detail-pro .crm-actions-bar{background:#031425;border:1px solid #0b4d78;border-radius:22px}
            .contact-detail-pro .crm-btn{border:1px solid #24537a;background:#0b2740;color:#f5fbff;border-radius:999px;padding:10px 14px;font-size:12px;font-weight:700}
            .contact-detail-pro .crm-btn:hover{background:#10324f;border-color:#d4af37}
            .contact-detail-pro .crm-btn-primary{background:#d4af37;color:#081a2b;border-color:#d4af37}
            .contact-detail-pro .crm-btn-primary:hover{background:#e8c457}
            .contact-detail-pro .crm-input{width:100%;border:1px solid #0b5f91;border-radius:.85rem;padding:.65rem .75rem;font-size:12px;outline:none;background:#0b2740;color:#fff}
            .contact-detail-pro .crm-input::placeholder{color:#7ea8c7}
            .contact-detail-pro .crm-input:focus{border-color:#d4af37;box-shadow:0 0 0 2px rgba(212,175,55,.18)}
            .contact-detail-pro .crm-label{display:block;font-size:11px;color:#8fb9da;margin-bottom:6px;font-weight:700;text-transform:uppercase;letter-spacing:.14em}
            .contact-detail-pro table{border-collapse:separate;border-spacing:0;background:#061a2f}
            .contact-detail-pro table tbody tr{transition:background .18s ease, box-shadow .18s ease;background:#08233d!important}
            .contact-detail-pro table tbody tr:nth-child(even){background:#092a49!important}
            .contact-detail-pro table tbody tr:hover{background:rgba(56,189,248,.075)!important;box-shadow:inset 3px 0 0 #d4af37}
            .contact-detail-pro table tbody td{border-top:1px solid #24587c;background:transparent!important;color:#f5fbff}
            .contact-detail-pro table thead th{position:sticky;top:0;z-index:10;background:#061a2f!important;color:#8fb9da;border-bottom:1px solid #24587c;text-transform:uppercase;letter-spacing:.13em}
            .contact-detail-pro .crm-scroll{overflow:auto;max-height:70vh}
            .contact-detail-pro .crm-scroll-top{overflow-x:auto;overflow-y:hidden;height:14px;border:1px solid #24587c;border-radius:999px;background:#061a2f;margin:0 12px 8px 12px}
            .contact-detail-pro .crm-scroll-spacer{height:1px;min-width:1100px}
            .contact-detail-pro .crm-scroll::-webkit-scrollbar,.contact-detail-pro .crm-scroll-top::-webkit-scrollbar{height:10px;width:10px}
            .contact-detail-pro .crm-scroll::-webkit-scrollbar-track,.contact-detail-pro .crm-scroll-top::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .contact-detail-pro .crm-scroll::-webkit-scrollbar-thumb,.contact-detail-pro .crm-scroll-top::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .contact-detail-pro .crm-scroll::-webkit-scrollbar-thumb:hover,.contact-detail-pro .crm-scroll-top::-webkit-scrollbar-thumb:hover{background:#d4af37}
            .contact-detail-pro .grid-row-main{font-weight:700;color:#fff!important}
            .contact-detail-pro .grid-row-sub{color:#9fc4df!important;font-size:12px}
            .contact-detail-pro .crm-badge{display:inline-flex;align-items:center;border-radius:999px;border:1px solid #24537a;background:#0f2d48;color:#d9e8f5;padding:4px 9px;font-size:10px;font-weight:700}
            .contact-detail-pro .crm-modal-panel{background:#04192b;border:1px solid #0b5f91;color:#fff;box-shadow:0 20px 60px rgba(0,0,0,.35)}
            .contact-detail-pro .crm-modal-head{background:#031425;border-bottom:1px solid #0b4d78}
        `}</style>
    );
}


function authHeaders(extra = {}) {
    const token = localStorage.getItem("cani_auth") || "";
    return {
        ...extra,
        Authorization: `Bearer ${token}`,
        "X-CANI-AUTH": token,
    };
}

function Badge({ children, tone = "default" }) {
    const styles = {
        default: "bg-[#08233d] text-white border-[#0b4d78]",
        green: "bg-[#0b3a36] text-[#7cebd0] border-[#10b981]/40",
        gray: "bg-gray-50 text-[#d9e8f5] border-gray-200",
        blue: "bg-[#0b3552] text-[#7dd3fc] border-[#0ea5e9]/45",
        amber: "bg-[#3a3110] text-[#f6d76b] border-[#d4af37]/45",
        red: "bg-[#2b1117] text-[#fca5a5] border-[#ef4444]/40",
    };

    return (
        <span className={`inline-flex px-2 py-1 rounded-full border text-[10px] ${styles[tone] || styles.default}`}>
            {children}
        </span>
    );
}

function SectionCard({ title, subtitle, right, children }) {
    return (
        <div className="crm-card rounded-[24px] overflow-hidden">
            <div className="crm-card-head px-5 py-4 flex items-start justify-between gap-3">
                <div>
                    <h3 className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#d4af37]">{title}</h3>
                    {subtitle ? <p className="text-[11px] text-[#9fc4df] mt-0.5">{subtitle}</p> : null}
                </div>
                {right ? <div>{right}</div> : null}
            </div>
            <div className="p-4">{children}</div>
        </div>
    );
}

function EmptyState({ text = "Sin información." }) {
    return <div className="text-xs text-[#8fb9da]">{text}</div>;
}

function InfoItem({ label, value }) {
    return (
        <div>
            <div className="text-[10px] uppercase tracking-wide text-[#9fc4df] mb-1">{label}</div>
            <div className="text-xs text-white break-words">{value || "—"}</div>
        </div>
    );
}

function formatDate(value) {
    if (!value) return "No capturado";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleDateString("es-MX", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}

function formatDateTime(value) {
    if (!value) return "—";
    const normalized = String(value).replace(" ", "T");
    const d = new Date(normalized);
    if (Number.isNaN(d.getTime())) return value;
    return d.toLocaleString("es-MX", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
    });
}

function normalizeDateTimeForApi(value) {
    if (!value) return null;
    return value.replace("T", " ") + ":00";
}

function toDateTimeLocal(value) {
    if (!value) return "";
    const str = String(value).trim();
    if (!str) return "";
    if (str.includes("T")) return str.slice(0, 16);
    return str.replace(" ", "T").slice(0, 16);
}

function AccountSearchBox({
    accountsCatalog,
    linkedAccounts,
    query,
    setQuery,
    selectedId,
    setSelectedId,
}) {
    const filtered = useMemo(() => {
        const linkedIds = new Set(linkedAccounts.map((a) => String(a.id)));
        const q = query.trim().toLowerCase();

        return accountsCatalog
            .filter((acc) => !linkedIds.has(String(acc.id)))
            .filter((acc) => {
                if (!q) return true;
                return [
                    acc.name,
                    acc.alias,
                    acc.city,
                    acc.state,
                    acc.country,
                    acc.industry,
                    acc.type,
                ]
                    .filter(Boolean)
                    .some((field) => String(field).toLowerCase().includes(q));
            })
            .slice(0, 30);
    }, [accountsCatalog, linkedAccounts, query]);

    return (
        <div className="space-y-3">
            <div>
                <label className="crm-label">Buscar cuenta</label>
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Nombre, alias, ciudad, industria..."
                    className="crm-input"
                />
            </div>

            <div>
                <label className="crm-label">Seleccionar cuenta</label>
                <select
                    value={selectedId}
                    onChange={(e) => setSelectedId(e.target.value)}
                    className="crm-input"
                >
                    <option value="">— Seleccionar cuenta —</option>
                    {filtered.map((acc) => (
                        <option key={acc.id} value={acc.id}>
                            {acc.name}
                            {acc.alias ? ` · ${acc.alias}` : ""}
                            {acc.city ? ` · ${acc.city}` : ""}
                        </option>
                    ))}
                </select>
            </div>

            {filtered.length === 0 ? (
                <div className="text-[11px] text-[#8fb9da]">
                    No hay cuentas disponibles con ese criterio o ya están vinculadas.
                </div>
            ) : null}
        </div>
    );
}

function OpportunitySearchBox({
    opportunitiesCatalog,
    directOpportunities,
    query,
    setQuery,
    selectedId,
    setSelectedId,
}) {
    const filtered = useMemo(() => {
        const linkedIds = new Set(directOpportunities.map((o) => String(o.id)));
        const q = query.trim().toLowerCase();

        return opportunitiesCatalog
            .filter((opp) => !linkedIds.has(String(opp.id)))
            .filter((opp) => {
                if (!q) return true;
                return [
                    opp.name,
                    opp.stage,
                    opp.status,
                    opp.account_name,
                    opp.description,
                ]
                    .filter(Boolean)
                    .some((field) => String(field).toLowerCase().includes(q));
            })
            .slice(0, 40);
    }, [opportunitiesCatalog, directOpportunities, query]);

    return (
        <div className="space-y-3">
            <div>
                <label className="crm-label">Buscar oportunidad</label>
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Nombre, cuenta, etapa..."
                    className="crm-input"
                />
            </div>

            <div>
                <label className="crm-label">Seleccionar oportunidad</label>
                <select
                    value={selectedId}
                    onChange={(e) => setSelectedId(e.target.value)}
                    className="crm-input"
                >
                    <option value="">— Seleccionar oportunidad —</option>
                    {filtered.map((opp) => (
                        <option key={opp.id} value={opp.id}>
                            {opp.name}
                            {opp.account_name ? ` · ${opp.account_name}` : ""}
                            {opp.stage ? ` · ${opp.stage}` : opp.status ? ` · ${opp.status}` : ""}
                        </option>
                    ))}
                </select>
            </div>

            {filtered.length === 0 ? (
                <div className="text-[11px] text-[#8fb9da]">
                    No hay oportunidades disponibles con ese criterio o ya están vinculadas directamente.
                </div>
            ) : null}
        </div>
    );
}

function ProjectSearchBox({
    projectsCatalog,
    directProjects,
    query,
    setQuery,
    selectedId,
    setSelectedId,
}) {
    const filtered = useMemo(() => {
        const linkedIds = new Set(directProjects.map((p) => String(p.id)));
        const q = query.trim().toLowerCase();

        return projectsCatalog
            .filter((project) => !linkedIds.has(String(project.id)))
            .filter((project) => {
                if (!q) return true;
                return [
                    project.name,
                    project.code,
                    project.status,
                    project.account_name,
                    project.opportunity_name,
                    project.project_manager,
                    project.sponsor,
                ]
                    .filter(Boolean)
                    .some((field) => String(field).toLowerCase().includes(q));
            })
            .slice(0, 40);
    }, [projectsCatalog, directProjects, query]);

    return (
        <div className="space-y-3">
            <div>
                <label className="crm-label">Buscar proyecto</label>
                <input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Nombre, código, cuenta, oportunidad..."
                    className="crm-input"
                />
            </div>

            <div>
                <label className="crm-label">Seleccionar proyecto</label>
                <select
                    value={selectedId}
                    onChange={(e) => setSelectedId(e.target.value)}
                    className="crm-input"
                >
                    <option value="">— Seleccionar proyecto —</option>
                    {filtered.map((project) => (
                        <option key={project.id} value={project.id}>
                            {project.name}
                            {project.code ? ` · ${project.code}` : ""}
                            {project.account_name ? ` · ${project.account_name}` : ""}
                        </option>
                    ))}
                </select>
            </div>

            {filtered.length === 0 ? (
                <div className="text-[11px] text-[#8fb9da]">
                    No hay proyectos disponibles con ese criterio o ya están vinculados directamente.
                </div>
            ) : null}
        </div>
    );
}

const EMPTY_ACTIVITY_FORM = {
    account_id: "",
    opportunity_id: "",
    project_id: "",
    type: "llamada",
    channel: "",
    title: "",
    objective: "",
    result: "",
    status: "programada",
    start_datetime: "",
    end_datetime: "",
    next_action: "",
    next_action_date: "",
    notes: "",
};

function ContactActivityModal({
    open,
    onClose,
    mode,
    form,
    setForm,
    onSubmit,
    saving,
    accounts,
    opportunities,
    projects,
}) {
    if (!open) return null;

    const filteredOpps = opportunities.filter((o) =>
        !form.account_id ? true : String(o.account_id) === String(form.account_id)
    );

    const filteredProjects = projects.filter((p) =>
        !form.account_id ? true : String(p.account_id) === String(form.account_id)
    );

    return (
        <>
            <div className="fixed inset-0 bg-[#010b14]/75 backdrop-blur-sm z-[90]" onClick={onClose} />
            <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
                <div className="w-full max-w-4xl max-h-[92vh] overflow-auto crm-modal-panel rounded-[24px]">
                    <div className="sticky top-0 crm-modal-head px-5 py-4 flex items-center justify-between z-10">
                        <div>
                            <h3 className="text-sm font-semibold text-white">
                                {mode === "edit" ? "Editar actividad del contacto" : "Nueva actividad del contacto"}
                            </h3>
                            <p className="text-[11px] text-[#9fc4df]">
                                Registra interacción directa con la persona.
                            </p>
                        </div>

                        <button
                            type="button"
                            onClick={onClose}
                            className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-xs text-[#d9e8f5] hover:bg-[#10324f]"
                        >
                            Cerrar
                        </button>
                    </div>

                    <form onSubmit={onSubmit} className="p-4 space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                            <div>
                                <label className="crm-label">Cuenta</label>
                                <select
                                    value={form.account_id}
                                    onChange={(e) =>
                                        setForm((prev) => ({
                                            ...prev,
                                            account_id: e.target.value,
                                            opportunity_id: "",
                                            project_id: "",
                                        }))
                                    }
                                    className="crm-input"
                                >
                                    <option value="">Sin cuenta</option>
                                    {accounts.map((acc) => (
                                        <option key={acc.id} value={acc.id}>
                                            {acc.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="crm-label">Oportunidad</label>
                                <select
                                    value={form.opportunity_id}
                                    onChange={(e) =>
                                        setForm((prev) => ({ ...prev, opportunity_id: e.target.value }))
                                    }
                                    className="crm-input"
                                >
                                    <option value="">Sin oportunidad</option>
                                    {filteredOpps.map((opp) => (
                                        <option key={opp.id} value={opp.id}>
                                            {opp.name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="crm-label">Proyecto</label>
                                <select
                                    value={form.project_id}
                                    onChange={(e) =>
                                        setForm((prev) => ({ ...prev, project_id: e.target.value }))
                                    }
                                    className="crm-input"
                                >
                                    <option value="">Sin proyecto</option>
                                    {filteredProjects.map((project) => (
                                        <option key={project.id} value={project.id}>
                                            {project.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                            <div>
                                <label className="crm-label">Tipo</label>
                                <select
                                    value={form.type}
                                    onChange={(e) => setForm((prev) => ({ ...prev, type: e.target.value }))}
                                    className="crm-input"
                                >
                                    <option value="llamada">Llamada</option>
                                    <option value="correo">Correo</option>
                                    <option value="whatsapp">WhatsApp</option>
                                    <option value="reunion_presencial">Reunión presencial</option>
                                    <option value="reunion_virtual">Reunión virtual</option>
                                    <option value="comida">Comida</option>
                                    <option value="evento">Evento</option>
                                    <option value="otro">Otro</option>
                                </select>
                            </div>

                            <div>
                                <label className="crm-label">Canal</label>
                                <input
                                    type="text"
                                    value={form.channel}
                                    onChange={(e) => setForm((prev) => ({ ...prev, channel: e.target.value }))}
                                    className="crm-input"
                                    placeholder="Teléfono, Zoom, Teams..."
                                />
                            </div>

                            <div>
                                <label className="crm-label">Estatus</label>
                                <select
                                    value={form.status}
                                    onChange={(e) => setForm((prev) => ({ ...prev, status: e.target.value }))}
                                    className="crm-input"
                                >
                                    <option value="programada">Programada</option>
                                    <option value="realizada">Realizada</option>
                                    <option value="cancelada">Cancelada</option>
                                    <option value="seguimiento">Seguimiento</option>
                                </select>
                            </div>

                            <div>
                                <label className="crm-label">Título</label>
                                <input
                                    type="text"
                                    value={form.title}
                                    onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
                                    className="crm-input"
                                    placeholder="Seguimiento con dirección..."
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div>
                                <label className="crm-label">Objetivo</label>
                                <textarea
                                    rows={3}
                                    value={form.objective}
                                    onChange={(e) => setForm((prev) => ({ ...prev, objective: e.target.value }))}
                                    className="crm-input resize-none"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Resultado</label>
                                <textarea
                                    rows={3}
                                    value={form.result}
                                    onChange={(e) => setForm((prev) => ({ ...prev, result: e.target.value }))}
                                    className="crm-input resize-none"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div>
                                <label className="crm-label">Inicio</label>
                                <input
                                    type="datetime-local"
                                    value={form.start_datetime}
                                    onChange={(e) => setForm((prev) => ({ ...prev, start_datetime: e.target.value }))}
                                    className="crm-input"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Fin</label>
                                <input
                                    type="datetime-local"
                                    value={form.end_datetime}
                                    onChange={(e) => setForm((prev) => ({ ...prev, end_datetime: e.target.value }))}
                                    className="crm-input"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                            <div>
                                <label className="crm-label">Próximo paso</label>
                                <input
                                    type="text"
                                    value={form.next_action}
                                    onChange={(e) => setForm((prev) => ({ ...prev, next_action: e.target.value }))}
                                    className="crm-input"
                                />
                            </div>

                            <div>
                                <label className="crm-label">Fecha próximo paso</label>
                                <input
                                    type="datetime-local"
                                    value={form.next_action_date}
                                    onChange={(e) => setForm((prev) => ({ ...prev, next_action_date: e.target.value }))}
                                    className="crm-input"
                                />
                            </div>
                        </div>

                        <div>
                            <label className="crm-label">Notas</label>
                            <textarea
                                rows={3}
                                value={form.notes}
                                onChange={(e) => setForm((prev) => ({ ...prev, notes: e.target.value }))}
                                className="crm-input resize-none"
                            />
                        </div>

                        <div className="flex justify-end gap-2">
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-xs text-[#d9e8f5] hover:bg-[#10324f]"
                            >
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                disabled={saving}
                                className="px-3 py-1.5 rounded-lg bg-cani-primary text-white text-xs hover:bg-cani-primaryLight disabled:opacity-60"
                            >
                                {saving ? "Guardando..." : mode === "edit" ? "Guardar cambios" : "Crear actividad"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default function ContactDetailPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [data, setData] = useState(null);

    const [accountsCatalog, setAccountsCatalog] = useState([]);
    const [accountsCatalogLoading, setAccountsCatalogLoading] = useState(false);

    const [opportunitiesCatalog, setOpportunitiesCatalog] = useState([]);
    const [opportunitiesCatalogLoading, setOpportunitiesCatalogLoading] = useState(false);

    const [projectsCatalog, setProjectsCatalog] = useState([]);
    const [projectsCatalogLoading, setProjectsCatalogLoading] = useState(false);

    const [directActivities, setDirectActivities] = useState([]);
    const [directActivitiesLoading, setDirectActivitiesLoading] = useState(false);

    const [activityModalOpen, setActivityModalOpen] = useState(false);
    const [activityModalMode, setActivityModalMode] = useState("create");
    const [activitySaving, setActivitySaving] = useState(false);
    const [activityDeletingId, setActivityDeletingId] = useState(null);
    const [editingActivityId, setEditingActivityId] = useState(null);
    const [activityForm, setActivityForm] = useState(EMPTY_ACTIVITY_FORM);

    const [attachQuery, setAttachQuery] = useState("");
    const [attachAccountId, setAttachAccountId] = useState("");
    const [attachRoleLabel, setAttachRoleLabel] = useState("");
    const [attachIsPrimary, setAttachIsPrimary] = useState(false);
    const [attaching, setAttaching] = useState(false);
    const [detachingId, setDetachingId] = useState(null);
    const [promotingId, setPromotingId] = useState(null);

    const [oppAttachQuery, setOppAttachQuery] = useState("");
    const [oppAttachId, setOppAttachId] = useState("");
    const [oppAttachRoleLabel, setOppAttachRoleLabel] = useState("");
    const [oppAttachIsPrimary, setOppAttachIsPrimary] = useState(false);
    const [attachingOpportunity, setAttachingOpportunity] = useState(false);
    const [detachingOpportunityId, setDetachingOpportunityId] = useState(null);
    const [promotingOpportunityId, setPromotingOpportunityId] = useState(null);

    const [projectAttachQuery, setProjectAttachQuery] = useState("");
    const [projectAttachId, setProjectAttachId] = useState("");
    const [projectAttachRoleLabel, setProjectAttachRoleLabel] = useState("");
    const [projectAttachIsPrimary, setProjectAttachIsPrimary] = useState(false);
    const [attachingProject, setAttachingProject] = useState(false);
    const [detachingProjectId, setDetachingProjectId] = useState(null);
    const [promotingProjectId, setPromotingProjectId] = useState(null);

    async function loadDetail() {
        const res = await fetch(`${API_BASE}/contact_detail.php?id=${id}`, {
            headers: authHeaders(),
        });

        const json = await res.json().catch(() => ({}));

        if (!res.ok || json.success === false) {
            throw new Error(json.error || "No se pudo cargar el detalle del contacto.");
        }

        setData(json);
    }

    async function loadAccountsCatalog() {
        setAccountsCatalogLoading(true);
        try {
            const res = await fetch(`${API_BASE}/accounts_list.php`, {
                headers: authHeaders(),
            });
            const json = await res.json().catch(() => []);
            setAccountsCatalog(Array.isArray(json) ? json : []);
        } finally {
            setAccountsCatalogLoading(false);
        }
    }

    async function loadOpportunitiesCatalog() {
        setOpportunitiesCatalogLoading(true);
        try {
            const res = await fetch(`${API_BASE}/opportunities_list.php`, {
                headers: authHeaders(),
            });
            const json = await res.json().catch(() => []);
            setOpportunitiesCatalog(Array.isArray(json) ? json : []);
        } finally {
            setOpportunitiesCatalogLoading(false);
        }
    }

    async function loadProjectsCatalog() {
        setProjectsCatalogLoading(true);
        try {
            const res = await fetch(`${API_BASE}/projects_list.php`, {
                headers: authHeaders(),
            });
            const json = await res.json().catch(() => []);
            setProjectsCatalog(Array.isArray(json) ? json : []);
        } finally {
            setProjectsCatalogLoading(false);
        }
    }

    async function loadDirectActivities() {
        setDirectActivitiesLoading(true);
        try {
            const res = await fetch(`${API_BASE}/contact_activities_list.php?contact_id=${id}`, {
                headers: authHeaders(),
            });
            const json = await res.json().catch(() => ({}));

            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudieron cargar las actividades directas.");
            }

            setDirectActivities(Array.isArray(json.items) ? json.items : []);
        } finally {
            setDirectActivitiesLoading(false);
        }
    }

    useEffect(() => {
        let ignore = false;

        async function run() {
            try {
                setLoading(true);
                setError("");

                await Promise.all([
                    loadDetail(),
                    loadAccountsCatalog(),
                    loadOpportunitiesCatalog(),
                    loadProjectsCatalog(),
                    loadDirectActivities(),
                ]);

                if (ignore) return;
            } catch (err) {
                console.error(err);
                if (!ignore) setError(err.message || "Error al cargar el detalle.");
            } finally {
                if (!ignore) setLoading(false);
            }
        }

        run();
        return () => {
            ignore = true;
        };
    }, [id]);

    const contact = data?.contact || null;
    const affiliateCompanies = data?.affiliate_companies || [];
    const relatedAccounts = data?.accounts || [];
    const opportunities = data?.opportunities || [];
    const directOpportunities = data?.direct_opportunities || [];
    const projects = data?.projects || [];
    const directProjects = data?.direct_projects || [];
    const activities = data?.activities || [];

    const contactStatusTone = useMemo(() => {
        return (contact?.status || "").toLowerCase() === "activo" ? "green" : "gray";
    }, [contact]);

    const summary = useMemo(() => {
        return {
            accounts: relatedAccounts.length,
            primaryAccounts: relatedAccounts.filter((a) => Number(a.is_primary) === 1).length,
            opportunities: opportunities.length,
            directOpportunities: directOpportunities.length,
            projects: projects.length,
            directProjects: directProjects.length,
            directActivities: directActivities.length,
            activities: activities.length,
        };
    }, [relatedAccounts, opportunities, directOpportunities, projects, directProjects, directActivities, activities]);

    async function refreshAll() {
        try {
            setError("");
            await Promise.all([loadDetail(), loadDirectActivities()]);
        } catch (err) {
            console.error(err);
            setError(err.message || "No se pudo refrescar el detalle.");
        }
    }

    function openNewActivityModal() {
        setActivityModalMode("create");
        setEditingActivityId(null);
        setActivityForm(EMPTY_ACTIVITY_FORM);
        setActivityModalOpen(true);
    }

    function openEditActivityModal(activity) {
        setActivityModalMode("edit");
        setEditingActivityId(activity.id);
        setActivityForm({
            account_id: activity.account_id ? String(activity.account_id) : "",
            opportunity_id: activity.opportunity_id ? String(activity.opportunity_id) : "",
            project_id: activity.project_id ? String(activity.project_id) : "",
            type: activity.type || "llamada",
            channel: activity.channel || "",
            title: activity.title || "",
            objective: activity.objective || "",
            result: activity.result || "",
            status: activity.status || "programada",
            start_datetime: toDateTimeLocal(activity.start_datetime),
            end_datetime: toDateTimeLocal(activity.end_datetime),
            next_action: activity.next_action || "",
            next_action_date: toDateTimeLocal(activity.next_action_date),
            notes: activity.notes || "",
        });
        setActivityModalOpen(true);
    }

    function closeActivityModal() {
        setActivityModalOpen(false);
        setEditingActivityId(null);
        setActivityModalMode("create");
        setActivityForm(EMPTY_ACTIVITY_FORM);
    }

    async function handleSubmitActivity(e) {
        e.preventDefault();

        if (!activityForm.title.trim()) {
            setError("El título de la actividad es obligatorio.");
            return;
        }

        try {
            setActivitySaving(true);
            setError("");

            const payload = {
                contact_id: Number(id),
                account_id: activityForm.account_id ? Number(activityForm.account_id) : null,
                opportunity_id: activityForm.opportunity_id ? Number(activityForm.opportunity_id) : null,
                project_id: activityForm.project_id ? Number(activityForm.project_id) : null,
                type: activityForm.type || "otro",
                channel: activityForm.channel || null,
                title: activityForm.title.trim(),
                objective: activityForm.objective || null,
                result: activityForm.result || null,
                status: activityForm.status || null,
                start_datetime: activityForm.start_datetime
                    ? normalizeDateTimeForApi(activityForm.start_datetime)
                    : null,
                end_datetime: activityForm.end_datetime
                    ? normalizeDateTimeForApi(activityForm.end_datetime)
                    : null,
                next_action: activityForm.next_action || null,
                next_action_date: activityForm.next_action_date
                    ? normalizeDateTimeForApi(activityForm.next_action_date)
                    : null,
                notes: activityForm.notes || null,
            };

            let endpoint = `${API_BASE}/contact_activity_create.php`;

            if (activityModalMode === "edit" && editingActivityId) {
                endpoint = `${API_BASE}/contact_activity_update.php`;
                payload.id = editingActivityId;
            }

            const res = await fetch(endpoint, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            const json = await res.json().catch(() => ({}));

            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo guardar la actividad.");
            }

            closeActivityModal();
            await loadDirectActivities();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al guardar actividad.");
        } finally {
            setActivitySaving(false);
        }
    }

    async function handleDeleteActivity(activityId) {
        if (!window.confirm("¿Eliminar esta actividad del contacto?")) return;

        try {
            setActivityDeletingId(activityId);
            setError("");

            const res = await fetch(`${API_BASE}/contact_activity_delete.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({ id: activityId }),
            });

            const json = await res.json().catch(() => ({}));

            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo eliminar la actividad.");
            }

            await loadDirectActivities();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al eliminar actividad.");
        } finally {
            setActivityDeletingId(null);
        }
    }

    async function handleAttachAccount(e) {
        e.preventDefault();
        if (!attachAccountId) {
            setError("Selecciona una cuenta para vincular.");
            return;
        }

        try {
            setAttaching(true);
            setError("");

            const res = await fetch(`${API_BASE}/contact_accounts_attach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    contact_id: Number(id),
                    account_id: Number(attachAccountId),
                    role_label: attachRoleLabel || null,
                    is_primary: attachIsPrimary ? 1 : 0,
                }),
            });

            const json = await res.json().catch(() => ({}));
            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo vincular la cuenta.");
            }

            setAttachAccountId("");
            setAttachQuery("");
            setAttachRoleLabel("");
            setAttachIsPrimary(false);

            await refreshAll();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al vincular cuenta.");
        } finally {
            setAttaching(false);
        }
    }

    async function handleDetachAccount(accountId) {
        if (!window.confirm("¿Desvincular esta cuenta del contacto?")) return;

        try {
            setDetachingId(accountId);
            setError("");

            const res = await fetch(`${API_BASE}/contact_accounts_detach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    contact_id: Number(id),
                    account_id: Number(accountId),
                }),
            });

            const json = await res.json().catch(() => ({}));
            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo desvincular la cuenta.");
            }

            await refreshAll();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al desvincular cuenta.");
        } finally {
            setDetachingId(null);
        }
    }

    async function handleMakePrimary(account) {
        try {
            setPromotingId(account.id);
            setError("");

            const res = await fetch(`${API_BASE}/contact_accounts_attach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    contact_id: Number(id),
                    account_id: Number(account.id),
                    role_label: account.role_label || null,
                    is_primary: 1,
                }),
            });

            const json = await res.json().catch(() => ({}));
            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo marcar la cuenta como principal.");
            }

            await refreshAll();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al marcar principal.");
        } finally {
            setPromotingId(null);
        }
    }

    async function handleAttachOpportunity(e) {
        e.preventDefault();
        if (!oppAttachId) {
            setError("Selecciona una oportunidad para vincular.");
            return;
        }

        try {
            setAttachingOpportunity(true);
            setError("");

            const res = await fetch(`${API_BASE}/contact_opportunities_attach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    contact_id: Number(id),
                    opportunity_id: Number(oppAttachId),
                    role_label: oppAttachRoleLabel || null,
                    is_primary: oppAttachIsPrimary ? 1 : 0,
                }),
            });

            const json = await res.json().catch(() => ({}));
            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo vincular la oportunidad.");
            }

            setOppAttachId("");
            setOppAttachQuery("");
            setOppAttachRoleLabel("");
            setOppAttachIsPrimary(false);

            await refreshAll();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al vincular oportunidad.");
        } finally {
            setAttachingOpportunity(false);
        }
    }

    async function handleDetachOpportunity(opportunityId) {
        if (!window.confirm("¿Desvincular esta oportunidad del contacto?")) return;

        try {
            setDetachingOpportunityId(opportunityId);
            setError("");

            const res = await fetch(`${API_BASE}/contact_opportunities_detach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    contact_id: Number(id),
                    opportunity_id: Number(opportunityId),
                }),
            });

            const json = await res.json().catch(() => ({}));
            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo desvincular la oportunidad.");
            }

            await refreshAll();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al desvincular oportunidad.");
        } finally {
            setDetachingOpportunityId(null);
        }
    }

    async function handleMakePrimaryOpportunity(opportunity) {
        try {
            setPromotingOpportunityId(opportunity.id);
            setError("");

            const res = await fetch(`${API_BASE}/contact_opportunities_attach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    contact_id: Number(id),
                    opportunity_id: Number(opportunity.id),
                    role_label: opportunity.role_label || null,
                    is_primary: 1,
                }),
            });

            const json = await res.json().catch(() => ({}));
            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo marcar la oportunidad como principal.");
            }

            await refreshAll();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al marcar oportunidad principal.");
        } finally {
            setPromotingOpportunityId(null);
        }
    }

    async function handleAttachProject(e) {
        e.preventDefault();
        if (!projectAttachId) {
            setError("Selecciona un proyecto para vincular.");
            return;
        }

        try {
            setAttachingProject(true);
            setError("");

            const res = await fetch(`${API_BASE}/contact_projects_attach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    contact_id: Number(id),
                    project_id: Number(projectAttachId),
                    role_label: projectAttachRoleLabel || null,
                    is_primary: projectAttachIsPrimary ? 1 : 0,
                }),
            });

            const json = await res.json().catch(() => ({}));
            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo vincular el proyecto.");
            }

            setProjectAttachId("");
            setProjectAttachQuery("");
            setProjectAttachRoleLabel("");
            setProjectAttachIsPrimary(false);

            await refreshAll();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al vincular proyecto.");
        } finally {
            setAttachingProject(false);
        }
    }

    async function handleDetachProject(projectId) {
        if (!window.confirm("¿Desvincular este proyecto del contacto?")) return;

        try {
            setDetachingProjectId(projectId);
            setError("");

            const res = await fetch(`${API_BASE}/contact_projects_detach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    contact_id: Number(id),
                    project_id: Number(projectId),
                }),
            });

            const json = await res.json().catch(() => ({}));
            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo desvincular el proyecto.");
            }

            await refreshAll();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al desvincular proyecto.");
        } finally {
            setDetachingProjectId(null);
        }
    }

    async function handleMakePrimaryProject(project) {
        try {
            setPromotingProjectId(project.id);
            setError("");

            const res = await fetch(`${API_BASE}/contact_projects_attach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    contact_id: Number(id),
                    project_id: Number(project.id),
                    role_label: project.role_label || null,
                    is_primary: 1,
                }),
            });

            const json = await res.json().catch(() => ({}));
            if (!res.ok || json.success === false) {
                throw new Error(json.error || "No se pudo marcar el proyecto como principal.");
            }

            await refreshAll();
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al marcar proyecto principal.");
        } finally {
            setPromotingProjectId(null);
        }
    }

    return (
        <MainLayout>
            <ContactDetailLeadWebStyle />
            <div className="contact-detail-pro min-h-screen bg-[#041426] px-3 py-6 md:px-6 md:py-8"><div className="mx-auto max-w-[1500px] space-y-6">
                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                    <div>
                        <div className="flex items-center gap-2 flex-wrap">
                            <button
                                type="button"
                                onClick={() => navigate("/contacts")}
                                className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-xs text-[#d9e8f5] hover:bg-[#10324f]"
                            >
                                ← Volver a contactos
                            </button>
                            {contact?.status ? <Badge tone={contactStatusTone}>{contact.status}</Badge> : null}
                        </div>

                        <h2 className="text-lg md:text-xl font-semibold text-white mt-3">
                            {contact?.full_name || "Detalle de contacto"}
                        </h2>

                        <p className="text-xs md:text-sm text-[#9fc4df] mt-1">
                            Vista 360 del contacto: empresas, cuentas, oportunidades, proyectos y agenda relacionada.
                        </p>
                    </div>

                    <button
                        type="button"
                        onClick={openNewActivityModal}
                        className="px-3 py-2 rounded-lg bg-cani-primary text-white text-xs hover:bg-cani-primaryLight"
                    >
                        + Nueva actividad directa
                    </button>
                </div>

                {error && (
                    <div className="text-xs text-[#fca5a5] bg-[#2b1117] border border-[#ef4444]/40 rounded-lg px-3 py-2">
                        {error}
                    </div>
                )}

                {loading && (
                    <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-sm p-6 text-sm text-[#9fc4df]">
                        Cargando detalle del contacto...
                    </div>
                )}

                {!loading && !error && !contact && (
                    <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-sm p-6 text-sm text-[#9fc4df]">
                        No se encontró el contacto.
                    </div>
                )}

                {!loading && contact && (
                    <>
                        <div className="grid grid-cols-2 xl:grid-cols-8 gap-3">
                            <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                                <div className="text-[11px] text-[#9fc4df]">Cuentas</div>
                                <div className="text-xl font-semibold text-white">{summary.accounts}</div>
                            </div>
                            <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                                <div className="text-[11px] text-[#9fc4df]">Cuenta principal</div>
                                <div className="text-xl font-semibold text-white">{summary.primaryAccounts}</div>
                            </div>
                            <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                                <div className="text-[11px] text-[#9fc4df]">Oportunidades</div>
                                <div className="text-xl font-semibold text-white">{summary.opportunities}</div>
                            </div>
                            <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                                <div className="text-[11px] text-[#9fc4df]">Oport. directas</div>
                                <div className="text-xl font-semibold text-white">{summary.directOpportunities}</div>
                            </div>
                            <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                                <div className="text-[11px] text-[#9fc4df]">Proyectos</div>
                                <div className="text-xl font-semibold text-white">{summary.projects}</div>
                            </div>
                            <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                                <div className="text-[11px] text-[#9fc4df]">Proy. directos</div>
                                <div className="text-xl font-semibold text-white">{summary.directProjects}</div>
                            </div>
                            <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                                <div className="text-[11px] text-[#9fc4df]">Activ. directas</div>
                                <div className="text-xl font-semibold text-white">{summary.directActivities}</div>
                            </div>
                            <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl px-4 py-3 shadow-sm">
                                <div className="text-[11px] text-[#9fc4df]">Activ. por cuenta</div>
                                <div className="text-xl font-semibold text-white">{summary.activities}</div>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
                            <div className="xl:col-span-2">
                                <SectionCard
                                    title="Datos generales"
                                    subtitle="Información principal del contacto"
                                >
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        <InfoItem label="Nombre" value={contact.full_name} />
                                        <InfoItem label="Nombre(s)" value={contact.first_name} />
                                        <InfoItem label="Apellidos" value={contact.last_name} />
                                        <InfoItem label="Email" value={contact.email} />
                                        <InfoItem label="Teléfono" value={contact.phone} />
                                        <InfoItem label="Celular" value={contact.mobile} />
                                        <InfoItem label="Puesto" value={contact.position} />
                                        <InfoItem label="Cumpleaños" value={formatDate(contact.birthday)} />
                                        <InfoItem label="LinkedIn" value={contact.linkedin} />
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                                        <InfoItem label="Facebook" value={contact.facebook} />
                                        <InfoItem label="Instagram" value={contact.instagram} />
                                        <InfoItem label="Creado" value={formatDateTime(contact.created_at)} />
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                                        <InfoItem label="Información familiar" value={contact.family_info} />
                                        <InfoItem label="Notas de perfil" value={contact.profile_notes} />
                                        <InfoItem label="Notas personales" value={contact.personal_notes} />
                                    </div>
                                </SectionCard>
                            </div>

                            <div className="space-y-4">
                                <SectionCard
                                    title="Empresas afiliadas"
                                    subtitle="Vínculos desde affiliate_company_contacts"
                                    right={<Badge>{affiliateCompanies.length}</Badge>}
                                >
                                    {affiliateCompanies.length === 0 ? (
                                        <EmptyState text="Este contacto no tiene empresas afiliadas vinculadas." />
                                    ) : (
                                        <div className="space-y-2">
                                            {affiliateCompanies.map((company) => (
                                                <div key={company.id} className="border border-[#0b4d78] rounded-lg px-3 py-2">
                                                    <div className="text-[11px] font-semibold tracking-[0.22em] uppercase text-[#d4af37]">
                                                        {company.name}
                                                    </div>
                                                    <div className="text-[11px] text-[#9fc4df] mt-1">
                                                        {company.region || "Sin región"}
                                                        {company.city ? ` · ${company.city}` : ""}
                                                    </div>
                                                    <div className="text-[11px] text-[#9fc4df] mt-1">
                                                        {company.status || "Sin estatus"}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </SectionCard>

                                <SectionCard
                                    title="Vincular cuenta"
                                    subtitle="Relaciona este contacto con una o varias cuentas"
                                    right={accountsCatalogLoading ? <Badge>Cargando...</Badge> : null}
                                >
                                    <form onSubmit={handleAttachAccount} className="space-y-3">
                                        <AccountSearchBox
                                            accountsCatalog={accountsCatalog}
                                            linkedAccounts={relatedAccounts}
                                            query={attachQuery}
                                            setQuery={setAttachQuery}
                                            selectedId={attachAccountId}
                                            setSelectedId={setAttachAccountId}
                                        />

                                        <div>
                                            <label className="crm-label">
                                                Rol en la cuenta
                                            </label>
                                            <input
                                                type="text"
                                                value={attachRoleLabel}
                                                onChange={(e) => setAttachRoleLabel(e.target.value)}
                                                placeholder="Ej. Director, Compras, Sponsor, Operación..."
                                                className="crm-input"
                                            />
                                        </div>

                                        <label className="flex items-center gap-2 text-[11px] text-[#d9e8f5]">
                                            <input
                                                type="checkbox"
                                                checked={attachIsPrimary}
                                                onChange={(e) => setAttachIsPrimary(e.target.checked)}
                                            />
                                            Marcar como cuenta principal
                                        </label>

                                        <div className="flex justify-end">
                                            <button
                                                type="submit"
                                                disabled={attaching}
                                                className="px-3 py-1.5 rounded-lg bg-cani-primary text-white text-xs hover:bg-cani-primaryLight disabled:opacity-60"
                                            >
                                                {attaching ? "Vinculando..." : "Vincular cuenta"}
                                            </button>
                                        </div>
                                    </form>
                                </SectionCard>
                            </div>
                        </div>

                        <SectionCard
                            title="Cuentas vinculadas"
                            subtitle="Relación explícita desde account_contacts"
                            right={<Badge tone="blue">{relatedAccounts.length}</Badge>}
                        >
                            {relatedAccounts.length === 0 ? (
                                <EmptyState text="Este contacto aún no tiene cuentas vinculadas." />
                            ) : (
                                <div className="space-y-3">
                                    {relatedAccounts.map((account) => (
                                        <div key={account.id} className="border border-[#0b4d78] rounded-xl px-3 py-3">
                                            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                                                <div className="min-w-0">
                                                    <div className="flex items-center gap-2 flex-wrap">
                                                        <div className="text-sm font-semibold text-white">
                                                            {account.name}
                                                        </div>
                                                        {Number(account.is_primary) === 1 ? (
                                                            <Badge tone="green">Principal</Badge>
                                                        ) : null}
                                                        {account.role_label ? (
                                                            <Badge>{account.role_label}</Badge>
                                                        ) : null}
                                                    </div>

                                                    <div className="text-[11px] text-[#9fc4df] mt-1">
                                                        {account.alias || "Sin alias"}
                                                    </div>

                                                    <div className="text-[11px] text-[#9fc4df] mt-1">
                                                        {account.city || "Sin ciudad"}
                                                        {account.state ? ` · ${account.state}` : ""}
                                                        {account.country ? ` · ${account.country}` : ""}
                                                    </div>

                                                    <div className="flex flex-wrap gap-2 mt-2">
                                                        {account.type ? <Badge>{account.type}</Badge> : null}
                                                        {account.industry ? <Badge>{account.industry}</Badge> : null}
                                                        {account.strategic_level ? (
                                                            <Badge tone="amber">{account.strategic_level}</Badge>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div className="flex flex-wrap gap-2 lg:justify-end">
                                                    <Link
                                                        to={`/accounts/${account.id}`}
                                                        className="px-2 py-1 rounded-lg border border-[#0b4d78] text-[11px] hover:bg-[#10324f]"
                                                    >
                                                        Ver cuenta
                                                    </Link>

                                                    {Number(account.is_primary) !== 1 ? (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleMakePrimary(account)}
                                                            disabled={promotingId === account.id}
                                                            className="px-2 py-1 rounded-lg border border-[#0b4d78] text-[11px] hover:bg-[#10324f] disabled:opacity-60"
                                                        >
                                                            {promotingId === account.id ? "Guardando..." : "Hacer principal"}
                                                        </button>
                                                    ) : null}

                                                    <button
                                                        type="button"
                                                        onClick={() => handleDetachAccount(account.id)}
                                                        disabled={detachingId === account.id}
                                                        className="px-2 py-1 rounded-lg border border-[#ef4444]/40 text-[#fca5a5] text-[11px] hover:bg-[#2b1117] disabled:opacity-60"
                                                    >
                                                        {detachingId === account.id ? "Quitando..." : "Desvincular"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </SectionCard>

                        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
                            <div className="xl:col-span-2">
                                <SectionCard
                                    title="Oportunidades relacionadas"
                                    subtitle="Oportunidades del contacto: directas y por cuentas vinculadas"
                                    right={<Badge tone="blue">{opportunities.length}</Badge>}
                                >
                                    {opportunities.length === 0 ? (
                                        <EmptyState text="No hay oportunidades relacionadas con este contacto." />
                                    ) : (
                                        <div className="overflow-auto">
                                            <table className="min-w-full text-xs">
                                                <thead className="bg-[#08233d]">
                                                    <tr className="text-left text-[11px] font-semibold text-[#d7e8f6]">
                                                        <th className="px-3 py-2">Nombre</th>
                                                        <th className="px-3 py-2">Cuenta</th>
                                                        <th className="px-3 py-2">Etapa</th>
                                                        <th className="px-3 py-2">Tipo de relación</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {opportunities.map((row) => {
                                                        const isDirect = directOpportunities.some(
                                                            (d) => String(d.id) === String(row.id)
                                                        );
                                                        return (
                                                            <tr key={row.id} className="border-t border-[#0b4d78]">
                                                                <td className="px-3 py-2 text-white">
                                                                    <div className="font-medium">{row.name || "—"}</div>
                                                                    <div className="text-[11px] text-[#9fc4df] mt-1">
                                                                        {formatDate(row.created_at)}
                                                                    </div>
                                                                </td>
                                                                <td className="px-3 py-2 text-[#d7e8f6]">
                                                                    {relatedAccounts.find((a) => String(a.id) === String(row.account_id))?.name || "—"}
                                                                </td>
                                                                <td className="px-3 py-2 text-[#d7e8f6]">{row.stage || row.status || "—"}</td>
                                                                <td className="px-3 py-2 text-[#d7e8f6]">
                                                                    {isDirect ? <Badge tone="green">Directa</Badge> : <Badge>Por cuenta</Badge>}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </SectionCard>
                            </div>

                            <SectionCard
                                title="Vincular oportunidad"
                                subtitle="Relaciona este contacto directamente con oportunidades"
                                right={opportunitiesCatalogLoading ? <Badge>Cargando...</Badge> : null}
                            >
                                <form onSubmit={handleAttachOpportunity} className="space-y-3">
                                    <OpportunitySearchBox
                                        opportunitiesCatalog={opportunitiesCatalog}
                                        directOpportunities={directOpportunities}
                                        query={oppAttachQuery}
                                        setQuery={setOppAttachQuery}
                                        selectedId={oppAttachId}
                                        setSelectedId={setOppAttachId}
                                    />

                                    <div>
                                        <label className="crm-label">
                                            Rol en la oportunidad
                                        </label>
                                        <input
                                            type="text"
                                            value={oppAttachRoleLabel}
                                            onChange={(e) => setOppAttachRoleLabel(e.target.value)}
                                            placeholder="Ej. Champion, Sponsor, Comprador, Técnico..."
                                            className="crm-input"
                                        />
                                    </div>

                                    <label className="flex items-center gap-2 text-[11px] text-[#d9e8f5]">
                                        <input
                                            type="checkbox"
                                            checked={oppAttachIsPrimary}
                                            onChange={(e) => setOppAttachIsPrimary(e.target.checked)}
                                        />
                                        Marcar como oportunidad principal
                                    </label>

                                    <div className="flex justify-end">
                                        <button
                                            type="submit"
                                            disabled={attachingOpportunity}
                                            className="px-3 py-1.5 rounded-lg bg-cani-primary text-white text-xs hover:bg-cani-primaryLight disabled:opacity-60"
                                        >
                                            {attachingOpportunity ? "Vinculando..." : "Vincular oportunidad"}
                                        </button>
                                    </div>
                                </form>
                            </SectionCard>
                        </div>

                        <SectionCard
                            title="Oportunidades directas vinculadas"
                            subtitle="Relación explícita desde opportunity_contacts"
                            right={<Badge tone="green">{directOpportunities.length}</Badge>}
                        >
                            {directOpportunities.length === 0 ? (
                                <EmptyState text="Este contacto aún no tiene oportunidades directas vinculadas." />
                            ) : (
                                <div className="space-y-3">
                                    {directOpportunities.map((opp) => (
                                        <div key={opp.id} className="border border-[#0b4d78] rounded-xl px-3 py-3">
                                            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                                                <div className="min-w-0">
                                                    <div className="flex items-center gap-2 flex-wrap">
                                                        <div className="text-sm font-semibold text-white">
                                                            {opp.name}
                                                        </div>
                                                        {Number(opp.is_primary) === 1 ? (
                                                            <Badge tone="green">Principal</Badge>
                                                        ) : null}
                                                        {opp.role_label ? (
                                                            <Badge>{opp.role_label}</Badge>
                                                        ) : null}
                                                    </div>

                                                    <div className="text-[11px] text-[#9fc4df] mt-1">
                                                        {opp.stage || opp.status || "Sin etapa"}
                                                    </div>

                                                    <div className="text-[11px] text-[#9fc4df] mt-1">
                                                        {relatedAccounts.find((a) => String(a.id) === String(opp.account_id))?.name || "Sin cuenta"}
                                                    </div>
                                                </div>

                                                <div className="flex flex-wrap gap-2 lg:justify-end">
                                                    {Number(opp.is_primary) !== 1 ? (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleMakePrimaryOpportunity(opp)}
                                                            disabled={promotingOpportunityId === opp.id}
                                                            className="px-2 py-1 rounded-lg border border-[#0b4d78] text-[11px] hover:bg-[#10324f] disabled:opacity-60"
                                                        >
                                                            {promotingOpportunityId === opp.id ? "Guardando..." : "Hacer principal"}
                                                        </button>
                                                    ) : null}

                                                    <button
                                                        type="button"
                                                        onClick={() => handleDetachOpportunity(opp.id)}
                                                        disabled={detachingOpportunityId === opp.id}
                                                        className="px-2 py-1 rounded-lg border border-[#ef4444]/40 text-[#fca5a5] text-[11px] hover:bg-[#2b1117] disabled:opacity-60"
                                                    >
                                                        {detachingOpportunityId === opp.id ? "Quitando..." : "Desvincular"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </SectionCard>

                        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
                            <div className="xl:col-span-2">
                                <SectionCard
                                    title="Proyectos relacionados"
                                    subtitle="Proyectos del contacto: directos y por cuentas vinculadas"
                                    right={<Badge tone="amber">{projects.length}</Badge>}
                                >
                                    {projects.length === 0 ? (
                                        <EmptyState text="No hay proyectos relacionados con este contacto." />
                                    ) : (
                                        <div className="overflow-auto">
                                            <table className="min-w-full text-xs">
                                                <thead className="bg-[#08233d]">
                                                    <tr className="text-left text-[11px] font-semibold text-[#d7e8f6]">
                                                        <th className="px-3 py-2">Proyecto</th>
                                                        <th className="px-3 py-2">Cuenta</th>
                                                        <th className="px-3 py-2">Código</th>
                                                        <th className="px-3 py-2">Tipo de relación</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {projects.map((row) => {
                                                        const isDirect = directProjects.some(
                                                            (d) => String(d.id) === String(row.id)
                                                        );
                                                        return (
                                                            <tr key={row.id} className="border-t border-[#0b4d78]">
                                                                <td className="px-3 py-2 text-white">
                                                                    <div className="font-medium">{row.name || "—"}</div>
                                                                    {(row.start_date || row.end_date) && (
                                                                        <div className="text-[11px] text-[#9fc4df] mt-1">
                                                                            {formatDate(row.start_date)} {row.end_date ? `→ ${formatDate(row.end_date)}` : ""}
                                                                        </div>
                                                                    )}
                                                                </td>
                                                                <td className="px-3 py-2 text-[#d7e8f6]">{row.account_name || "—"}</td>
                                                                <td className="px-3 py-2 text-[#d7e8f6]">{row.code || "—"}</td>
                                                                <td className="px-3 py-2 text-[#d7e8f6]">
                                                                    {isDirect ? <Badge tone="green">Directo</Badge> : <Badge>Por cuenta</Badge>}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </SectionCard>
                            </div>

                            <SectionCard
                                title="Vincular proyecto"
                                subtitle="Relaciona este contacto directamente con proyectos"
                                right={projectsCatalogLoading ? <Badge>Cargando...</Badge> : null}
                            >
                                <form onSubmit={handleAttachProject} className="space-y-3">
                                    <ProjectSearchBox
                                        projectsCatalog={projectsCatalog}
                                        directProjects={directProjects}
                                        query={projectAttachQuery}
                                        setQuery={setProjectAttachQuery}
                                        selectedId={projectAttachId}
                                        setSelectedId={setProjectAttachId}
                                    />

                                    <div>
                                        <label className="crm-label">
                                            Rol en el proyecto
                                        </label>
                                        <input
                                            type="text"
                                            value={projectAttachRoleLabel}
                                            onChange={(e) => setProjectAttachRoleLabel(e.target.value)}
                                            placeholder="Ej. Sponsor, enlace, usuario clave, operación..."
                                            className="crm-input"
                                        />
                                    </div>

                                    <label className="flex items-center gap-2 text-[11px] text-[#d9e8f5]">
                                        <input
                                            type="checkbox"
                                            checked={projectAttachIsPrimary}
                                            onChange={(e) => setProjectAttachIsPrimary(e.target.checked)}
                                        />
                                        Marcar como proyecto principal
                                    </label>

                                    <div className="flex justify-end">
                                        <button
                                            type="submit"
                                            disabled={attachingProject}
                                            className="px-3 py-1.5 rounded-lg bg-cani-primary text-white text-xs hover:bg-cani-primaryLight disabled:opacity-60"
                                        >
                                            {attachingProject ? "Vinculando..." : "Vincular proyecto"}
                                        </button>
                                    </div>
                                </form>
                            </SectionCard>
                        </div>

                        <SectionCard
                            title="Proyectos directos vinculados"
                            subtitle="Relación explícita desde project_contacts"
                            right={<Badge tone="green">{directProjects.length}</Badge>}
                        >
                            {directProjects.length === 0 ? (
                                <EmptyState text="Este contacto aún no tiene proyectos directos vinculados." />
                            ) : (
                                <div className="space-y-3">
                                    {directProjects.map((project) => (
                                        <div key={project.id} className="border border-[#0b4d78] rounded-xl px-3 py-3">
                                            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                                                <div className="min-w-0">
                                                    <div className="flex items-center gap-2 flex-wrap">
                                                        <div className="text-sm font-semibold text-white">
                                                            {project.name}
                                                        </div>
                                                        {Number(project.is_primary) === 1 ? (
                                                            <Badge tone="green">Principal</Badge>
                                                        ) : null}
                                                        {project.role_label ? (
                                                            <Badge>{project.role_label}</Badge>
                                                        ) : null}
                                                    </div>

                                                    <div className="text-[11px] text-[#9fc4df] mt-1">
                                                        {project.code || "Sin código"} · {project.status || "Sin estatus"}
                                                    </div>

                                                    <div className="text-[11px] text-[#9fc4df] mt-1">
                                                        {project.account_name || "Sin cuenta"}
                                                    </div>
                                                </div>

                                                <div className="flex flex-wrap gap-2 lg:justify-end">
                                                    {Number(project.is_primary) !== 1 ? (
                                                        <button
                                                            type="button"
                                                            onClick={() => handleMakePrimaryProject(project)}
                                                            disabled={promotingProjectId === project.id}
                                                            className="px-2 py-1 rounded-lg border border-[#0b4d78] text-[11px] hover:bg-[#10324f] disabled:opacity-60"
                                                        >
                                                            {promotingProjectId === project.id ? "Guardando..." : "Hacer principal"}
                                                        </button>
                                                    ) : null}

                                                    <button
                                                        type="button"
                                                        onClick={() => handleDetachProject(project.id)}
                                                        disabled={detachingProjectId === project.id}
                                                        className="px-2 py-1 rounded-lg border border-[#ef4444]/40 text-[#fca5a5] text-[11px] hover:bg-[#2b1117] disabled:opacity-60"
                                                    >
                                                        {detachingProjectId === project.id ? "Quitando..." : "Desvincular"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </SectionCard>

                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                            <SectionCard
                                title="Actividades directas del contacto"
                                subtitle="Interacciones registradas específicamente con esta persona"
                                right={
                                    <div className="flex items-center gap-2">
                                        {directActivitiesLoading ? <Badge>Cargando...</Badge> : <Badge tone="green">{directActivities.length}</Badge>}
                                        <button
                                            type="button"
                                            onClick={openNewActivityModal}
                                            className="px-2 py-1 rounded-lg border border-[#0b4d78] text-[11px] hover:bg-[#10324f]"
                                        >
                                            + Nueva
                                        </button>
                                    </div>
                                }
                            >
                                {directActivities.length === 0 ? (
                                    <EmptyState text="No hay actividades directas registradas para este contacto." />
                                ) : (
                                    <div className="space-y-3">
                                        {directActivities.map((act) => (
                                            <div
                                                key={act.id}
                                                className="border border-[#0b4d78] rounded-xl px-3 py-3"
                                            >
                                                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-3">
                                                    <div className="min-w-0">
                                                        <div className="flex items-center gap-2 flex-wrap">
                                                            <div className="text-sm font-semibold text-white">
                                                                {act.title || "Sin título"}
                                                            </div>
                                                            {act.type ? <Badge>{act.type}</Badge> : null}
                                                            {act.status ? <Badge tone="blue">{act.status}</Badge> : null}
                                                        </div>

                                                        <div className="text-[11px] text-[#9fc4df] mt-1">
                                                            {formatDateTime(act.start_datetime)}
                                                        </div>

                                                        {(act.account_name || act.opportunity_name || act.project_name) && (
                                                            <div className="text-[11px] text-[#9fc4df] mt-1">
                                                                {act.account_name || "Sin cuenta"}
                                                                {act.opportunity_name ? ` · ${act.opportunity_name}` : ""}
                                                                {act.project_name ? ` · ${act.project_name}` : ""}
                                                            </div>
                                                        )}

                                                        {act.objective ? (
                                                            <div className="text-[11px] text-[#d7e8f6] mt-2">
                                                                <span className="font-medium">Objetivo:</span> {act.objective}
                                                            </div>
                                                        ) : null}

                                                        {act.result ? (
                                                            <div className="text-[11px] text-[#d7e8f6] mt-1">
                                                                <span className="font-medium">Resultado:</span> {act.result}
                                                            </div>
                                                        ) : null}

                                                        {act.next_action ? (
                                                            <div className="text-[11px] text-[#d7e8f6] mt-1">
                                                                <span className="font-medium">Próximo paso:</span> {act.next_action}
                                                                {act.next_action_date ? ` · ${formatDateTime(act.next_action_date)}` : ""}
                                                            </div>
                                                        ) : null}

                                                        {act.notes ? (
                                                            <div className="text-[11px] text-[#9fc4df] mt-1">
                                                                {act.notes}
                                                            </div>
                                                        ) : null}
                                                    </div>

                                                    <div className="flex flex-wrap gap-2 lg:justify-end">
                                                        <button
                                                            type="button"
                                                            onClick={() => openEditActivityModal(act)}
                                                            className="px-2 py-1 rounded-lg border border-[#0b4d78] text-[11px] hover:bg-[#10324f]"
                                                        >
                                                            Editar
                                                        </button>

                                                        <button
                                                            type="button"
                                                            onClick={() => handleDeleteActivity(act.id)}
                                                            disabled={activityDeletingId === act.id}
                                                            className="px-2 py-1 rounded-lg border border-[#ef4444]/40 text-[#fca5a5] text-[11px] hover:bg-[#2b1117] disabled:opacity-60"
                                                        >
                                                            {activityDeletingId === act.id ? "Eliminando..." : "Eliminar"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </SectionCard>

                            <SectionCard
                                title="Actividades por cuenta relacionadas"
                                subtitle="Interacciones registradas por cuenta vinculada al contacto"
                                right={<Badge>{activities.length}</Badge>}
                            >
                                {activities.length === 0 ? (
                                    <EmptyState text="No hay actividades relacionadas con las cuentas de este contacto." />
                                ) : (
                                    <div className="overflow-auto">
                                        <table className="min-w-full text-xs">
                                            <thead className="bg-[#08233d]">
                                                <tr className="text-left text-[11px] font-semibold text-[#d7e8f6]">
                                                    <th className="px-3 py-2">Fecha / hora</th>
                                                    <th className="px-3 py-2">Cuenta</th>
                                                    <th className="px-3 py-2">Tipo</th>
                                                    <th className="px-3 py-2">Título</th>
                                                    <th className="px-3 py-2">Estatus</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {activities.map((row) => (
                                                    <tr key={row.id} className="border-t border-[#0b4d78]">
                                                        <td className="px-3 py-2 text-[#d7e8f6]">{formatDateTime(row.start_datetime)}</td>
                                                        <td className="px-3 py-2 text-[#d7e8f6]">{row.account_name || "—"}</td>
                                                        <td className="px-3 py-2 text-[#d7e8f6]">{row.type || "—"}</td>
                                                        <td className="px-3 py-2 text-white">
                                                            <div className="font-medium">{row.title || "—"}</div>
                                                            {row.next_action ? (
                                                                <div className="text-[11px] text-[#9fc4df] mt-1">
                                                                    Próximo: {row.next_action}
                                                                </div>
                                                            ) : null}
                                                        </td>
                                                        <td className="px-3 py-2 text-[#d7e8f6]">{row.status || "—"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </SectionCard>
                        </div>
                    </>
                )}
            </div>

                <ContactActivityModal
                    open={activityModalOpen}
                    onClose={closeActivityModal}
                    mode={activityModalMode}
                    form={activityForm}
                    setForm={setActivityForm}
                    onSubmit={handleSubmitActivity}
                    saving={activitySaving}
                    accounts={relatedAccounts}
                    opportunities={opportunities}
                    projects={projects}
                />
            </div>
        </MainLayout>
    );
}
